import { lazy, Suspense } from "react";
import CircularLoader from "../../../customs/loader/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/eventDetails/main"));

const EventDetails = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
      
  );
};

export default EventDetails;

